// import '@/assets/scss/app.scss';
import reportWebVitals from '@/config/reportWebVitals';
import { isNewRelicConfig, nrConfigurations } from '@/constants/configuration/newRelic.js';
import { Router } from '@/lib/router-dom';
import store from '@/redux/store.js';
import { hydrateShellSession } from '@/redux/actions/auth.js';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';

const SHELL_HOSTED = process.env.REACT_APP_SHELL_HOSTED === 'true';

if (SHELL_HOSTED) {
	const token = typeof window !== 'undefined' ? sessionStorage.getItem('adminCoreToken') : null;
	if (token) {
		axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	}
}

if (!isNewRelicConfig()) {
	console.warn("Unknown environment for New Relic setup.");
} else {
	new BrowserAgent(nrConfigurations);
}

function renderApp() {
	ReactDOM.render(
		<React.StrictMode>
			<Provider store={store}>
				<Router basename={process.env.PUBLIC_URL}>
					<App />
				</Router>
			</Provider>
		</React.StrictMode>,
		document.getElementById('root')
	);
	reportWebVitals();
}

// Portal pre-fetches profile/features (and orgsys for pitstop users) at login.
// If a required key is missing here, force re-login via portal.
const adminToken = typeof window !== 'undefined' ? sessionStorage.getItem('adminCoreToken') : null;
const pitstopToken = typeof window !== 'undefined' ? sessionStorage.getItem('pitstopCoreToken') : null;
const hasProfile = typeof window !== 'undefined' && !!sessionStorage.getItem('profile');
const hasFeatures = typeof window !== 'undefined' && !!sessionStorage.getItem('features');
const hasOrgsys = typeof window !== 'undefined' && !!sessionStorage.getItem('orgsys');
const hasNavEntries = typeof window !== 'undefined' && !!sessionStorage.getItem('navEntries');
const orgsysOk = !pitstopToken || hasOrgsys;

const shouldRedirectToLogin =
	SHELL_HOSTED &&
	typeof window !== 'undefined' &&
	!!adminToken &&
	(!hasProfile || !hasFeatures || !orgsysOk || !hasNavEntries);

if (shouldRedirectToLogin) {
	console.warn('[admin-ui] Hydrate prerequisites missing — redirecting to portal /login', {
		hasProfile,
		hasFeatures,
		hasOrgsys,
		hasNavEntries,
		hasPitstopToken: !!pitstopToken,
		pathname: window.location.pathname,
	});
	window.location.assign('/login');
} else {
	const shouldHydrate =
		SHELL_HOSTED &&
		typeof window !== 'undefined' &&
		!!adminToken &&
		sessionStorage.getItem('profileSurface') !== 'admin';

	(async () => {
		if (shouldHydrate) {
			try {
				await store.dispatch(hydrateShellSession());
			} catch (_e) { /* let 401 interceptor handle */ }
		}
		renderApp();
	})();
}
